export default "__VITE_ASSET__BEuW_vuG__"